import React from "react";
import { MapPin, Phone, Clock, Facebook, Mail } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-[#362C2C] text-[#FFFBF8] py-20 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-brand-script text-[64px] md:text-[80px] text-[#E4D0D0] leading-[0.95] mb-6">
            Sweet Rose<br />Cookies
          </div>
          <p className="text-[#E4D0D0]/80 leading-relaxed max-w-sm">
            Custom sugar cookies, hand-iced with love in Aubrey, Texas. Birthdays,
            showers, holidays — if you're celebrating, we'll bake it.
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-[#E4D0D0] mb-5">
            Visit
          </div>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 text-[#E4D0D0] flex-none" />
              <a
                href={BRAND.mapsUrl}
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#E4D0D0] transition-colors"
                data-testid="footer-address"
              >
                {BRAND.address}
              </a>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="mt-0.5 text-[#E4D0D0] flex-none" />
              <a
                href={BRAND.phoneHref}
                className="hover:text-[#E4D0D0] transition-colors"
                data-testid="footer-phone"
              >
                {BRAND.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Clock size={16} className="mt-0.5 text-[#E4D0D0] flex-none" />
              <span data-testid="footer-hours">{BRAND.hours}</span>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="mt-0.5 text-[#E4D0D0] flex-none" />
              <a
                href={`mailto:${BRAND.email}`}
                className="hover:text-[#E4D0D0] transition-colors"
                data-testid="footer-email"
              >
                {BRAND.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-[#E4D0D0] mb-5">
            Follow
          </div>
          <a
            href={BRAND.facebook}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm hover:text-[#E4D0D0] transition-colors"
            data-testid="footer-facebook"
          >
            <Facebook size={16} />
            Facebook
          </a>

          <div className="mt-10">
            <a
              href="#order"
              className="inline-flex items-center gap-2 border border-[#E4D0D0]/40 text-[#FFFBF8] px-5 py-2.5 rounded-md hover:bg-[#E4D0D0]/10 transition-all text-sm tracking-wide"
              data-testid="footer-cta-order"
            >
              Request a Quote →
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-[#FFFBF8]/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#E4D0D0]/60">
        <span>© {new Date().getFullYear()} Sweet Rose Cookies · Aubrey, TX</span>
        <a
          href="/admin"
          className="hover:text-[#E4D0D0] transition-colors"
          data-testid="footer-admin-link"
        >
          Admin
        </a>
      </div>
    </footer>
  );
}
